@if (errorMessageKey()) {
  <p class="ul-inline-alert -critical">{{ errorMessageKey()! | translate }}</p>
} @else {
  <ng-content></ng-content>
  <mat-spinner></mat-spinner>
}
